export enum EmdSectorEnum {
  CONSUMER = "Consumer & Retail",
  FOOD_BEVERAGE = "Food & Beverage",
  GAMING = "Gaming",
  FINANCIALS_ASIA = "Financials Asia",
  FINANCIALS_CEEMA_HY = "Financials CEEMEA HY",
  FINANCIALS_CEEMA_IG = "Financials CEEMEA IG",
  FINANCIALS_LATIN = "Financials Latin America",
  INDUSTRIALS_GLOBAL = "Industrials Global",
  INFRASTRUCTURE_GLOBAL = "Infrastructure Global",
  METALS_MINING_HY = "Metals & Mining HY",
  METALS_MINING_IG = "Metals & Mining IG",
  OIL_GAS_INDEPENDENT = "Oil & Gas Independent",
  OIL_GAS_INTEGRATED = "Oil & Gas Integrated",
  PULP_PAPER_GLOBAL = "Pulp & Paper Global",
  REAL_ESTATE_CHINA = "Real Estate China",
  REAL_ESTATE_EX_CHINA = "Real Estate Ex-China",
  TMT_GLOBAL = "TMT Global",
  UTILITIES_HY = "Utilities HY",
  UTILITIES_IG = "Utilities IG"
}

export type EmdSectorValue = `${EmdSectorEnum}`

export type EmdSectorKey = keyof typeof EmdSectorEnum

export enum EmdEsgSectorGroupEnum {
  G_CONSUMER = "Consumer",
  G_FINANCIALS = "Financials",
  G_INDUSTRIAL = "Industrial",
  G_INFRASTRUCTURE = "Infrastructure",
  G_METALS_MINING = "Metals & Mining",
  G_OIL_GAS_INDEPENDENT = "Oil & Gas Independent",
  G_OIL_GAS_INTEGRATED = "Oil & Gas Integrated",
  G_PULP_PAPER = "Pulp & Paper",
  G_REAL_ESTATE = "Real Estate",
  G_TMT = "TMT",
  G_UTILITIES = "Utilities"
}

export type EmdEsgSectorGroupValue = `${EmdEsgSectorGroupEnum}`

export type EmdEsgSectorGroupKey = keyof typeof EmdEsgSectorGroupEnum

export const EmdSectorToSectorGroupmappings = new Map<EmdSectorEnum, EmdEsgSectorGroupEnum>([
  [EmdSectorEnum.CONSUMER, EmdEsgSectorGroupEnum.G_CONSUMER],
  [EmdSectorEnum.FOOD_BEVERAGE, EmdEsgSectorGroupEnum.G_CONSUMER],
  [EmdSectorEnum.GAMING, EmdEsgSectorGroupEnum.G_CONSUMER],
  [EmdSectorEnum.FINANCIALS_ASIA, EmdEsgSectorGroupEnum.G_FINANCIALS],
  [EmdSectorEnum.FINANCIALS_CEEMA_HY, EmdEsgSectorGroupEnum.G_FINANCIALS],
  [EmdSectorEnum.FINANCIALS_CEEMA_IG, EmdEsgSectorGroupEnum.G_FINANCIALS],
  [EmdSectorEnum.FINANCIALS_LATIN, EmdEsgSectorGroupEnum.G_FINANCIALS],
  [EmdSectorEnum.INDUSTRIALS_GLOBAL, EmdEsgSectorGroupEnum.G_INDUSTRIAL],
  [EmdSectorEnum.INFRASTRUCTURE_GLOBAL, EmdEsgSectorGroupEnum.G_INFRASTRUCTURE],
  [EmdSectorEnum.METALS_MINING_HY, EmdEsgSectorGroupEnum.G_METALS_MINING],
  [EmdSectorEnum.METALS_MINING_IG, EmdEsgSectorGroupEnum.G_METALS_MINING],
  [EmdSectorEnum.OIL_GAS_INDEPENDENT, EmdEsgSectorGroupEnum.G_OIL_GAS_INDEPENDENT],
  [EmdSectorEnum.OIL_GAS_INTEGRATED, EmdEsgSectorGroupEnum.G_OIL_GAS_INTEGRATED],
  [EmdSectorEnum.PULP_PAPER_GLOBAL, EmdEsgSectorGroupEnum.G_PULP_PAPER],
  [EmdSectorEnum.REAL_ESTATE_CHINA, EmdEsgSectorGroupEnum.G_REAL_ESTATE],
  [EmdSectorEnum.REAL_ESTATE_EX_CHINA, EmdEsgSectorGroupEnum.G_REAL_ESTATE],
  [EmdSectorEnum.TMT_GLOBAL, EmdEsgSectorGroupEnum.G_TMT],
  [EmdSectorEnum.UTILITIES_HY, EmdEsgSectorGroupEnum.G_UTILITIES],
  [EmdSectorEnum.UTILITIES_IG, EmdEsgSectorGroupEnum.G_UTILITIES]
])

export function getSectorKeyStringByValueString(value: EmdSectorValue): EmdSectorKey {
  const keys = Object.keys(EmdSectorEnum) as Array<EmdSectorKey>
  const key = keys.find((key) => EmdSectorEnum[key] === value)
  if (!key) {
    throw new Error(`value not exisiting in string enum as value: ${value}`)
  }
  return key
}

export function getSectorEnumByValueString(value: EmdSectorValue): EmdSectorEnum {
  const key = getSectorKeyStringByValueString(value)
  return EmdSectorEnum[key]
}

export function getSectorGroupKeyStringByValueString(value: EmdEsgSectorGroupValue): EmdEsgSectorGroupKey {
  const keys = Object.keys(EmdEsgSectorGroupEnum) as Array<EmdEsgSectorGroupKey>
  const key = keys.find((key) => EmdEsgSectorGroupEnum[key] === value)
  if (!key) {
    throw new Error(`value not exisiting in string enum as value: ${value}`)
  }
  return key
}

export function getSectorGroupEnumByValueString(value: EmdEsgSectorGroupValue): EmdEsgSectorGroupEnum {
  const key = getSectorGroupKeyStringByValueString(value)
  return EmdEsgSectorGroupEnum[key]
}
